const moment = require('moment')

const maxParallelRequests = 25
function sliceArray (longArray, size) {
  if (!size) {
    size = (longArray.length / maxParallelRequests) + 1
  }
  const arrayToSlice = longArray.slice()

  const arrayOfArrays = []
  for (let i = 0; i < arrayToSlice.length; i += size) {
    arrayOfArrays.push(arrayToSlice.slice(i, i + size))
  }

  return arrayOfArrays
}

function deviceWithFuelInfo (device) {
  return device.attributes.odooId || device.attributes.xpert ||
        device.attributes.fuel_tank_capacity
}

function calculateXpertDistance (date, positions) {
  const begin = moment(date, 'YYYY-MM-DD').startOf('day')
  const end = moment(date, 'YYYY-MM-DD').endOf('day')
  const datePositions = positions.filter(p => moment(p.fixTime).isAfter(begin) && moment(p.fixTime).isBefore(end))

  return datePositions.reduce((a, b) => a + b.attributes.distance, 0)
}

exports.sliceArray = sliceArray
exports.deviceWithFuelInfo = deviceWithFuelInfo
exports.calculateXpertDistance = calculateXpertDistance
exports.maxParallelRequests = maxParallelRequests
